"use client";

import { c as _c } from "react/compiler-runtime";
import { Carousel, type CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@repo/design-system/components/ui/carousel";
import { cn } from "@repo/design-system/utils/cn";
import { useEffect, useState } from "react";
import ChevronLeft from "~/components/icons/chevron-left-eon";
import ChevronRight from "~/components/icons/chevron-right-eon";
import type { Benefit } from "./benefits-eon";
import { FlipCard } from "./benefits-flipcard-eon";
export interface BenefitSliderProps {
  benefits: Benefit[];
}
export function BenefitSlider(t0) {
  const $ = _c(25);
  const {
    benefits
  } = t0;
  const [api, setApi] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  let t1;
  let t2;
  if ($[0] !== api) {
    t1 = () => {
      if (!api) {
        return;
      }
      const updateIndex = () => setCurrentIndex(api.selectedScrollSnap());
      updateIndex();
      api.on("select", updateIndex);
      return () => {
        api.off("select", updateIndex);
      };
    };
    t2 = [api];
    $[0] = api;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      align: "start",
      loop: true,
      skipSnaps: false
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== benefits) {
    t4 = benefits.map(_temp);
    $[4] = benefits;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <CarouselContent className="-ml-4">{t4}</CarouselContent>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CarouselPrevious aria-label="Previous benefit" className="relative inset-auto translate-x-0 translate-y-0 text-primary" icon={<ChevronLeft />} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== api || $[10] !== benefits || $[11] !== currentIndex) {
    let t8;
    if ($[13] !== api || $[14] !== benefits.length || $[15] !== currentIndex) {
      t8 = benefit_0 => <button aria-label={`Go to benefit ${benefit_0.id + 1} of ${benefits.length}`} className="group flex size-6 items-center justify-center" key={benefit_0.id} onClick={() => api?.scrollTo(benefit_0.id)} type="button"><span className={cn("size-3 rounded-full border border-primary transition-colors", currentIndex === benefit_0.id ? "bg-primary" : "bg-white group-hover:bg-primary/20")} /></button>;
      $[13] = api;
      $[14] = benefits.length;
      $[15] = currentIndex;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t7 = benefits.map(t8);
    $[9] = api;
    $[10] = benefits;
    $[11] = currentIndex;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <div className="flex items-center gap-2">{t7}</div>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CarouselNext aria-label="Next benefit" className="relative inset-auto translate-x-0 translate-y-0 text-primary" icon={<ChevronRight />} />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8) {
    t10 = <div className="mt-6 flex items-center justify-center gap-4">{t6}{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t5) {
    t11 = <Carousel className="w-full" opts={t3} setApi={setApi}>{t5}{t10}</Carousel>;
    $[22] = t10;
    $[23] = t5;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp(benefit) {
  return <CarouselItem className="min-h-[24rem] basis-full pl-4" key={benefit.id}><FlipCard {...benefit} /></CarouselItem>;
}